export const PAGE_PADDING = 18;
export const PAGE_GAP = 14;
export const FIT_MARGIN = 40;
export const MIN_ZOOM = 0.1;
export const ZOOM_EPSILON = 1e-3;
/* eslint-disable @typescript-eslint/no-magic-numbers */
export const ZOOM_STEPS = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2, 3, 4];
/* eslint-enable @typescript-eslint/no-magic-numbers */
export const MAX_DPR = 3;
export const TILE_DELAY_MS = 90;
export const THUMBNAIL_WIDTH = 140;
export const THUMBNAIL_FRAME = 6;
export const THUMBNAIL_MARGIN = '400px 0px';
export const OVERVIEW_MARGIN = '1500px 0px';
export const SCROLL_ANCHOR = 0.35;
export const SEARCH_MIN_CHARS = 3;
export const SEARCH_DEBOUNCE_MS = 300;
export const SEARCH_BATCH = 100;
export const SEARCH_LIMIT = 200;
export const SEARCH_MAX_RESULTS = 1000;
export const SEARCH_SCROLL_OFFSET = 3;
export const SIDEBAR_WIDTH = 225;
export const SIDEBAR_MIN_WIDTH = 140;
export const SIDEBAR_MAX_WIDTH = 420;
export const OUTLINE_INDENT = 16;
export const OUTLINE_BASE_PADDING = 10;
export const ZOOM_SETTLE_MS = 150;
export const ZOOM_ANIMATION_MS = 140;
export const WHEEL_ZOOM_SPEED = 0.0025;
export const OVERVIEW_WIDTH_STEP = 100;
export const OVERVIEW_MIN_WIDTH = 200;
export const OVERVIEW_MAX_WIDTH = 2400;
export const RENDER_ZOOM_STEPS_PER_OCTAVE = 1;
export const RENDER_ZOOM_MIN_SHARPNESS = 0.9;
export const RENDER_ZOOM_MAX_OVERSAMPLE = 4;
export const MAX_RENDER_ZOOM = 8;
export const MIN_RENDER_ZOOM = 0.05;
export const ZOOM_REFERENCE_LINE = 0.35;
export const TILE_EPSILON_STEP = 1e-6;
export const NARROW_QUERY = '(max-width: 640px)';
export const TOUCH_QUERY = '(hover: none) and (pointer: coarse)';
export const DOUBLE_TAP_MS = 300;
export const DOUBLE_TAP_SLOP = 30;
export const DOUBLE_TAP_ZOOM_FACTOR = 2.5;
export const DOUBLE_TAP_RESET_RATIO = 1.15;
export const PAGE_SIDE_PADDING = 20;
